WiseMetering.Model.TariffType = WiseMetering.Model.extend({
    availableTemplates: {
        'es_cooled_water_energy_single': 'single',
        'es_electricity_single': 'single',
        'es_electricity_six_periods': 'es/six_periods',
        'es_gas_energy_single': 'single',
        'es_gas_volume_single': 'single',
        'es_hot_water_energy_single': 'single',
        'es_oil_single': 'single',
        'es_water_single': 'single',
        'gb_electricity_double': 'gb/double',
        'gb_electricity_single': 'gb/single',
        'gb_electricity_triple': 'gb/triple',
        'it_cooled_water_energy_single': 'single',
        'it_electricity_single': 'single',
        'it_gas_energy_single': 'single',
        'it_gas_volume_single': 'single',
        'it_hot_water_energy_single': 'single',
        'it_oil_single': 'single',
        'it_water_single': 'single',
        'pt_cooled_water_energy_clima_espaco': 'pt/clima_espaco',
        'pt_cooled_water_energy_single': 'single',
        'pt_electricity_daily_bte': 'pt/bte',
        'pt_electricity_daily_btn': 'pt/bt',
        'pt_electricity_luz_boa_bte': 'pt/luz_boa',
        'pt_electricity_luz_boa_btn_over21': 'pt/luz_boa',
        'pt_electricity_luz_boa_mt': 'pt/luz_boa',
        'pt_electricity_single': 'single',
        'pt_electricity_week_bte': 'pt/bte',
        'pt_electricity_week_btn': 'pt/bt',
        'pt_electricity_week_mt': 'pt/bte',
        'pt_gas_energy_range': 'pt/gas_range',
        'pt_gas_energy_single': 'single',
        'pt_gas_volume_single': 'single',
        'pt_hot_water_energy_clima_espaco': 'pt/clima_espaco',
        'pt_hot_water_energy_single': 'single',
        'pt_oil_single': 'single',
        'pt_water_range': 'pt/water_range',
        'pt_water_single': 'single'
    },

    extraTemplates: {
        'es_electricity_six_periods': 'six_periods',
        'pt_electricity_daily_bte': 'contracted_power',
        'pt_electricity_daily_btn': 'contracted_power',
        'pt_electricity_luz_boa_bte': 'contracted_power',
        'pt_electricity_luz_boa_btn_over21': 'contracted_power',
        'pt_electricity_luz_boa_mt': 'contracted_power',
        'pt_electricity_single': 'contracted_power',
        'pt_electricity_week_bte': 'contracted_power',
        'pt_electricity_week_btn': 'contracted_power',
        'pt_electricity_week_mt': 'contracted_power'
    },

    extraTemplate: function() {
        return this.extraTemplates[this.get('slug')] || null;
    },

    template: function() {
        return this.availableTemplates[this.get('slug')] || alert(`no template for ${this.get('type')}`);
    }
});
